export default import.meta.ROLLDOWN_FILE_URL_U0qri4zUpkK0i5QhPa58Mw